import { Space, Button, Row } from 'antd'
import { AvatarStatus } from 'components/elements/AvatarStatus'
import BaseTag from 'components/elements/BaseTag'
import { BtnAnch } from 'components/elements/global'
import { FC, useState } from 'react'
import { useUpdateLeadlogdataStatusMutation } from 'features/leads'
import { formatDate } from 'utils/functions'
import ViewAttachments from 'components/elements/ViewAttachments'
import { TInboxItemMsgs } from '../types'

const MessageBlockPanel: FC<{
 item: TInboxItemMsgs
 onClickReply?: () => void
 onClickForward?: () => void
 refetch?: () => void
}> = ({ item, onClickReply, onClickForward, refetch }) => {
 const [show, setShow] = useState(false)
 const [updateLeadlogdataStatus] = useUpdateLeadlogdataStatusMutation()

 const updateLeadLog = async (eid: any): Promise<void> => {
  await updateLeadlogdataStatus?.({ id: eid, type: 'email' }).unwrap()
  refetch?.()
 }
 return (
  <div className="msg-blk-panel">
   <div className="msg-blk-panel-header">
    <AvatarStatus
     title={item?.from_name ?? ''}
     titleNode={
      <BtnAnch
       onClick={() => {
        if (
         ['received', 'Received']?.includes(item?.send_type ?? '') &&
         item?.status !== 'Opened'
        ) {
         updateLeadLog?.(item?.id)
        }
        setShow((prv) => !prv)
       }}
       className="avt-hdrnoder"
      >
       <h5>{item?.from_name ? `${item?.from_name} > ${item?.to_name}` : ''}</h5>
       {item?.status && (
        <BaseTag
         tooltiOptions={{ overlayStyle: { maxWidth: '450px' } }}
         showTooltip={item?.error_message !== null}
         tooltipContent={item?.error_message}
         label={item?.status}
         color={item?.error_message ? 'red' : 'blue'}
        />
       )}
      </BtnAnch>
     }
     subTitle={item?.updated_at ? formatDate?.(item?.updated_at) : ''}
     action={
      <Space>
       <Button onClick={onClickReply} size="small" title="Reply">
        <i className="far fa-reply" />
       </Button>
       <Button onClick={onClickForward} size="small" title="Forward">
        <i className="far fa-share" />
       </Button>
       <Button onClick={() => setShow((prv) => !prv)} size="small">
        <i className={`far fa-angle-${show ? 'up' : 'down'}`} />
       </Button>
      </Space>
     }
    />
   </div>
   {show && (
    <div className="msg-blk-panel-body">
     <h4 className="subject-blk">Subject: {item?.subject}</h4>
     <div className="d-flex">
      {item?.cc_email?.length ? (
       <span className="me-2" style={{ fontWeight: '500' }}>
        Cc:
       </span>
      ) : (
       ''
      )}
      <div className="d-flex flex-wrap">
       {item?.cc_email?.map((i, n) => (
        <span key={n} className="me-2" style={{ fontWeight: '500' }}>
         {i}
         {n === (item?.cc_email?.length ?? 0) - 1 ? '' : ','}
        </span>
       ))}
      </div>
     </div>
     <div
      className="mt-2 msg-body"
      style={{ overflowWrap: 'break-word' }}
      dangerouslySetInnerHTML={{ __html: `${item?.body}` }}
     />
     {/* <div className="attachments-wrapper"> */}
     {/* {item?.attachment?.map?.((v: any, index) => (
       <a
        target={
         ['jpg', 'jpeg', 'png', 'svg', 'txt', 'pdf']?.includes(
          v?.split('.').at(-1),
         )
          ? '_blank'
          : '_self'
        }
        href={v}
        key={index}
        rel="noreferrer"
       >
        <div className="attachment">
         <i className="fas fa-file" />
        </div>
       </a>
      ))} */}
     <ViewAttachments attachments={item?.attachment} mode="row" />
     {/* </div> */}
    </div>
   )}
  </div>
 )
}

export default MessageBlockPanel

MessageBlockPanel.defaultProps = {
 onClickForward: undefined,
 onClickReply: undefined,
}
